import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useContext } from "react";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { PostRequest } from "../../utils/ApiServices";
import axiosInterceptor from "../../utils/axiosInterceptor";
import { GlobalContext } from "../../context/GlobalState";

function PaymentSelection() {
  const navigate = useNavigate();
  const [myJwtCookie] = useCookies(["jwt"]);
  const { userState } = useContext(GlobalContext);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    const user = myJwtCookie?.user;
    if (!user) {
      navigate("/login");
      return;
    }

    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    if (cart.length === 0) {
      navigate("/cart");
      return;
    }

    // Calculate total identical to TabbyPayment / StripePayment logic
    const sum = cart.reduce((acc, curr) => {
      let price = curr.price;
      return acc + price * (curr?.enrolment_quantity || 1);
    }, 0);
    const amount = sum + sum * 0.05; // Added 5% VAT / trans fee

    setTotalAmount(amount);
  }, [myJwtCookie, navigate]);

  const handlePaymentSelect = (type) => {
    localStorage.setItem("paymentType", JSON.stringify(type));
    
    if (type === "tabby") {
      navigate("/tabby-payment");
    } else {
      navigate("/stripe-payment");
    }
  };

  return (
    <>
      <style>{`
        .ps-wrapper {
          width: 100%;
          min-height: 50vh;
          display: flex;
          justify-content: center;
          margin-top: 200px;
          margin-bottom: 80px;
          background: #fff;
        }
        .ps-inner {
          width: 80%;
          max-width: 1200px;
          text-align: left !important;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        .ps-title, .ps-amount, .ps-methods-title, .ps-footer {
          margin: 0;
          padding: 0;
          text-align: left !important;
          width: 100%;
        }
        .ps-title {
          font-size: 26px;
          font-weight: 700;
          color: #2b313b;
          margin-bottom: 20px;
        }
        .ps-amount {
          font-size: 52px;
          font-weight: 700;
          color: #4f5e71;
          margin-bottom: 60px;
        }
        .ps-methods-title {
          font-size: 24px;
          font-weight: 700;
          color: #2b313b;
          margin-bottom: 28px;
        }
        .ps-buttons {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
          width: 100%;
          justify-content: flex-start;
        }
        .ps-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px 36px;
          border-radius: 50px;
          border: none;
          cursor: pointer;
          font-size: 18px;
          font-weight: 600;
          transition: opacity 0.2s;
          white-space: nowrap;
        }
        .ps-btn:hover {
          opacity: 0.9;
        }
        .ps-btn-stripe {
          background: #cba358;
          color: #fff;
          gap: 12px;
        }
        .ps-btn-tabby {
          background: #eaebed;
          color: #2b313b;
          gap: 12px;
        }
        .tabby-badge {
          background: #3cebcf;
          color: #1a1a1a;
          padding: 8px 18px;
          border-radius: 12px;
          font-weight: 800;
          font-size: 20px;
          letter-spacing: -1px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ps-footer {
          margin-top: 50px;
          font-size: 14px;
          color: #333;
        }
        .ps-back {
          margin-top: 32px;
          background: none;
          border: none;
          color: #888;
          font-size: 15px;
          cursor: pointer;
          text-decoration: underline;
          padding: 0;
        }
        @media (max-width: 768px) {
          .ps-wrapper {
            margin-top: 150px;
          }
          .ps-inner {
            width: 90%;
          }
        }
        @media (max-width: 500px) {
          .ps-buttons {
            flex-direction: column;
          }
          .ps-btn {
            width: 100%;
          }
        }
      `}</style>
      
      <div className="ps-wrapper">
        <div className="ps-inner">
          <h2 className="ps-title">Total Amount</h2>
          <h1 className="ps-amount">{totalAmount.toFixed(2)} AED</h1>

          <h3 className="ps-methods-title">Pay with</h3>
          <div className="ps-buttons">
            {/* Stripe Button */}
            <button 
              className="ps-btn ps-btn-stripe"
              onClick={() => handlePaymentSelect("stripe")}
            >
              Credit / Debit Card
              <i className="icofont-credit-card" style={{fontSize: "24px"}}></i>
            </button>

            {/* Tabby Button */}
            <button 
              className="ps-btn ps-btn-tabby"
              disabled={isLoading}
              onClick={() => handlePaymentSelect("tabby")}
            >
              {isLoading ? <Spinner animation="border" size="sm" /> : (
                <>
                  Pay by Installments via 
                  <div className="tabby-badge">tabby</div>
                </>
              )}
            </button>
          </div>

          <div className="ps-footer">
            * All the payments are processed securely through encrypted connections.
            <div>
              <button 
                onClick={() => navigate("/cart")}
                className="ps-back"
              >
                ← Back to Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentSelection;
